export const translations = {
    es: {
        nav: {
            home: "Inicio",
            sports: "Deportes",
            casino: "Casino",
            my_bets: "Apuestas",
            profile: "Perfil",
            admin_panel: "Panel Admin",
            deposit: "Depositar"
        },
        header: {
            deposit: "DEPOSITAR",
            login: "Entrar",
            register: "Registro",
            wallet_title: "Tu Billetera",
            currency_local: "Moneda Local",
            currency_usdt: "Tether (USDT)",
            currency_bonus: "Bono Promo"
        },
        footer: {
            help_center: "Centro de Ayuda",
            legal_docs: "Documentación Legal",
            regulations: "Reglamentos",
            social_media: "Redes Sociales",
            support: "Soporte 24/7",
            faq: "Preguntas Frecuentes",
            guide: "Guía de Inicio",
            payments: "Depósitos y Retiros",
            terms: "Términos y Condiciones",
            privacy: "Política de Privacidad",
            cookies: "Política de Cookies",
            responsible_gaming: "Juego Responsable",
            rules_sports: "Reglas de Deportes",
            rules_casino: "Reglas de Casino",
            aml_policy: "Política de AML",
            kyc_process: "Verificación KYC",
            follow_us: "Síguenos para bonos y noticias exclusivas.",
            adults_only: "Solo mayores",
            ssl_secure: "Seguridad SSL",
            ddos_protect: "Protección DDoS",
            license: "Licencia de Juego",
            copyright: "2026 PrimeApuesta © Todos los derechos reservados.",
            disclaimer: "PrimeApuesta es operada por Prime Gaming International Ltd. bajo licencia de Curacao Gaming Board (CGB) que garantiza entornos de juego justos y auditados externamente. El juego puede ser adictivo, por favor juegue con moderación. Queda prohibida la participación de menores de 18 años."
        },
        sidebar: {
            server_online: "Servidor Online",
            popular_sports: "DEPORTES POPULARES",
            other_sports: "OTROS DEPORTES",
            competitions: "COMPETICIONES",
            no_leagues: "No hay ligas activas"
        },
        home: {
            search_placeholder: "Buscar liga o equipo...",
            live_now: "VIVO AHORA",
            no_live_events: "No hay eventos en vivo",
            live_tag: "EN VIVO",
            live_competitions: "COMPETICIONES LIVE",
            top_events: "Eventos Top",
            more_markets: "+ Mercados"
        },
        common: {
            loading: "Cargando...",
            error: "Error",
            success: "Éxito",
            unknown_user: "Usuario",
            unknown_id: "ID Desconocido",
            selection_removed: "Selección eliminada",
            added_to_slip: "Añadido al boleto",
            login_required: "Inicia sesión para apostar",
            bet_success: "¡Apuesta Realizada con Éxito!",
            bet_error: "Error al procesar apuesta",
            home_team: "Local",
            away_team: "Visita",
            draw: "Empate",
            tournament: "Torneo",
            live: "En Vivo",
            my_account: "Mi Cuenta",
            premium_tag: "v2.0 Premium",
            view_in_dev: "Vista en desarrollo",
            active: "Activos"
        },
        lobby: {
            casino_category: "Casino",
            crash_title: "Rocket Crash",
            crash_subtitle: "Multiplicador x1000",
            blackjack_title: "Blackjack VIP",
            blackjack_subtitle: "Mesa en Vivo",
            roulette_title: "Roulette Gold",
            roulette_subtitle: "Premios x36",
            promo_exclusive: "PROMO EXCLUSIVA",
            deposit_promo_bs: "DEPÓSITO QR\n100% EXTRA",
            deposit_promo_crypto: "CRYPTO BONUS\n50% REGALO",
            claim: "RECLAMAR",
            live_matches: "Partidos en Vivo",
            featured_events: "Eventos Destacados",
            active_count: "ACTIVOS",
            waiting_live: "Esperando próximos inicios...",
            casino_universe: "Universo Casino",
            explore: "Explorar",
            popular_tag: "POPULAR",
            crash_desc: "Gana hasta x1500 en segundos",
            play_now: "JUGAR AHORA",
            upcoming_featured: "Próximos Destacados",
            home_label: "LOCAL",
            loading_sched: "Cargando cartelera..."
        },
        games: {
            crash: "Crash Rocket",
            blackjack: "Blackjack VIP",
            roulette: "Ruleta En Vivo",
            slots: "Mega Slots",
            mines: "Minas de Oro"
        },
        profile: {
            title: "Perfil",
            vip_level: "Nivel VIP 1",
            account_data: "Datos de Cuenta",
            email: "Correo Electrónico",
            phone: "Teléfono",
            kyc_status: "Verificación KYC",
            kyc_verified: "Aprobado",
            kyc_pending: "Pendiente",
            finance: "Finanzas",
            main_method: "Método Principal",
            wallets: "Billeteras",
            activity: "Actividad",
            transactions: "Transacciones",
            my_bets: "Mis Apuestas",
            stats: "Estadísticas",
            security: "Seguridad",
            password: "Contraseña",
            two_factor: "Seguridad 2FA",
            logout: "Cerrar Sesión Segura",
            admin_panel: "Panel Administrativo",
            admin_desc: "Gestión de Plataforma",
            settings: "Configuración",
            language: "Idioma",
            theme: "Tema",
            system_info: "SISTEMA PRIME APUESTA",
            version: "VERSIÓN 2.1.0 • NODO SEGURO",
            config: "Configuración",
            balance: "Saldo",
            total_balance: "Saldo Disponible",
            change: "Cambiar",
            real_money: "Dinero Real",
            active_bonus: "Bono Activo",
            deposit: "Depositar",
            withdraw: "Retirar",
            transactions_desc: "Historial de movimientos",
            my_bets_desc: "Tus tickets de apuestas",
            stats_desc: "Análisis de rendimiento",
            two_factor_desc: "Protección adicional",
            view_profile: "Ver mi perfil",
            cancel: "Cancelar"
        },
        settings: {
            dark_mode: "Modo Oscuro",
            light_mode: "Modo Claro",
            spanish: "Español",
            english: "Inglés",
            theme_desc: "Apariencia de la App",
            lang_desc: "Idioma del Sistema"
        }
    },
    en: {
        nav: {
            home: "Home",
            sports: "Sports",
            casino: "Casino",
            my_bets: "My Bets",
            profile: "Profile",
            admin_panel: "Admin Panel",
            deposit: "Deposit"
        },
        header: {
            deposit: "DEPOSIT",
            login: "Login",
            register: "Register",
            wallet_title: "Your Wallet",
            currency_local: "Local Currency",
            currency_usdt: "Tether (USDT)",
            currency_bonus: "Promo Bonus"
        },
        footer: {
            help_center: "Help Center",
            legal_docs: "Legal Documentation",
            regulations: "Regulations",
            social_media: "Social Media",
            support: "24/7 Support",
            faq: "FAQ",
            guide: "Start Guide",
            payments: "Deposits & Withdrawals",
            terms: "Terms & Conditions",
            privacy: "Privacy Policy",
            cookies: "Cookies Policy",
            responsible_gaming: "Responsible Gaming",
            rules_sports: "Sports Rules",
            rules_casino: "Casino Rules",
            aml_policy: "AML Policy",
            kyc_process: "KYC Verification",
            follow_us: "Follow us for bonuses and exclusive news.",
            adults_only: "18+ Only",
            ssl_secure: "SSL Security",
            ddos_protect: "DDoS Protection",
            license: "Gaming License",
            copyright: "2026 PrimeApuesta © All rights reserved.",
            disclaimer: "PrimeApuesta is operated by Prime Gaming International Ltd. under Curacao Gaming Board (CGB) license ensuring fair and audited gaming environments. Gambling can be addictive, please play responsibly. Participation of minors under 18 is prohibited."
        },
        sidebar: {
            server_online: "Server Online",
            popular_sports: "POPULAR SPORTS",
            other_sports: "OTHER SPORTS",
            competitions: "COMPETITIONS",
            no_leagues: "No active leagues"
        },
        home: {
            search_placeholder: "Search league or team...",
            live_now: "LIVE NOW",
            no_live_events: "No live events",
            live_tag: "LIVE",
            live_competitions: "LIVE COMPETITIONS",
            top_events: "Top Events",
            more_markets: "+ Markets"
        },
        common: {
            loading: "Loading...",
            error: "Error",
            success: "Success",
            unknown_user: "User",
            unknown_id: "Unknown ID",
            selection_removed: "Selection removed",
            added_to_slip: "Added to betslip",
            login_required: "Login to place bet",
            bet_success: "Bet Placed Successfully!",
            bet_error: "Error processing bet",
            home_team: "Home",
            away_team: "Away",
            draw: "Draw",
            tournament: "Tournament",
            live: "Live",
            my_account: "My Account",
            premium_tag: "v2.0 Premium",
            view_in_dev: "View under development",
            active: "Active"
        },
        lobby: {
            casino_category: "Casino",
            crash_title: "Rocket Crash",
            crash_subtitle: "Multiplier x1000",
            blackjack_title: "Blackjack VIP",
            blackjack_subtitle: "Live Table",
            roulette_title: "Roulette Gold",
            roulette_subtitle: "Prizes x36",
            promo_exclusive: "EXCLUSIVE PROMO",
            deposit_promo_bs: "QR DEPOSIT\n100% EXTRA",
            deposit_promo_crypto: "CRYPTO BONUS\n50% GIFT",
            claim: "CLAIM",
            live_matches: "Live Matches",
            featured_events: "Featured Events",
            active_count: "ACTIVE",
            waiting_live: "Waiting for upcoming...",
            casino_universe: "Casino Universe",
            explore: "Explore",
            popular_tag: "POPULAR",
            crash_desc: "Win up to x1500 in seconds",
            play_now: "PLAY NOW",
            upcoming_featured: "Upcoming Featured",
            home_label: "HOME",
            loading_sched: "Loading schedule..."
        },
        games: {
            crash: "Crash Rocket",
            blackjack: "Blackjack VIP",
            roulette: "Live Roulette",
            slots: "Mega Slots",
            mines: "Gold Mines"
        },
        profile: {
            title: "Profile",
            vip_level: "VIP Level 1",
            account_data: "Account Data",
            email: "Email",
            phone: "Phone",
            kyc_status: "KYC Verification",
            kyc_verified: "Verified",
            kyc_pending: "Pending",
            finance: "Finance",
            main_method: "Main Method",
            wallets: "Wallets",
            activity: "Activity",
            transactions: "Transactions",
            my_bets: "My Bets",
            stats: "Statistics",
            security: "Security",
            password: "Password",
            two_factor: "2FA Security",
            logout: "Secure Logout",
            admin_panel: "Admin Panel",
            admin_desc: "Platform Management",
            settings: "Settings",
            language: "Language",
            theme: "Theme",
            system_info: "PRIME APUESTA SYSTEM",
            version: "VERSION 2.1.0 • SECURE NODE",
            config: "Configuration",
            balance: "Balance",
            total_balance: "Total Balance",
            change: "Change",
            real_money: "Real Money",
            active_bonus: "Active Bonus",
            deposit: "Deposit",
            withdraw: "Withdraw",
            transactions_desc: "Transaction history",
            my_bets_desc: "Your betting tickets",
            stats_desc: "Performance analysis",
            two_factor_desc: "Additional protection",
            view_profile: "View my profile",
            cancel: "Cancel"
        },
        settings: {
            dark_mode: "Dark Mode",
            light_mode: "Light Mode",
            spanish: "Spanish",
            english: "English",
            theme_desc: "App Appearance",
            lang_desc: "System Language"
        }
    }
};
